define([
	'components/utilities/utilities',
	'components/pubsub/pubsub',
	'libs/nanoajax'
], function (utils, pubsub, nanoajax) {
	'use strict';

	/**
	 * searchTracking
	 * Some helpers for the search-page
	 * @version 1.0.0
	 * @exports searchTracking
	 */
	var searchTracking = {
		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._addEventListener();
		},



		_addEventListener: function () {
			utils.addEventListener(document, 'click', function (event) {
				var currentTag = event.target;

				while (currentTag !== null && currentTag.getAttribute && currentTag.getAttribute('data-hitid') === null) {
					currentTag = currentTag.parentNode;
				}

				if (currentTag !== null && currentTag.getAttribute && currentTag.getAttribute('data-hitid') !== null) {
					var hitId = currentTag.getAttribute('data-hitid'),
						trackId = currentTag.getAttribute('data-trackid'),
						query = currentTag.getAttribute('data-query'),
						url = '/api/clicktracking/track?query=' + query + '&hitId=' + hitId + '&trackId=' + trackId;

					nanoajax.ajax({
						method: 'GET',
						headers: {
							'X-Requested-With': 'XMLHttpRequest'
						},
						url: url
					});
				}
			});
		}
	};


	return searchTracking;
});



//////////////////
// WEBPACK FOOTER
// ./components/searchTracking/searchTracking.js
// module id = 59
// module chunks = 12